import qs from 'qs'
import Vue from 'vue'
import Router from 'vue-router'
import { pages } from './pages'
import { handleRoute } from './helpers'
import { installSafeNavigation, trackHistory } from './navigation'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  parseQuery: (q) => qs.parse(q),
  stringifyQuery: (q) => (Object.keys(q).length !== 0 ? `?${qs.stringify(q)}` : ''),
  routes: pages
})

installSafeNavigation(router)
trackHistory(router)
router.beforeEach(handleRoute)

export default router
